import React, { useEffect } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { FailedSolutionsSection } from '../components/sales/FailedSolutionsSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { WhatYouGetSection } from '../components/sales/WhatYouGetSection';
import { WhoIsForSection } from '../components/sales/WhoIsForSection';
import { CTASection } from '../components/sales/CTASection';
import { Footer } from '../components/sales/Footer';
import { initMetaPixel, trackPageView } from '../hooks/useMetaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-163">
      <main data-id="element-164">
        <HeroSection data-id="element-165" />
        <ProblemSection data-id="element-166" />
        <FailedSolutionsSection data-id="element-167" />
        <MechanismSection data-id="element-168" />
        <WhatYouGetSection data-id="element-169" />
        <WhoIsForSection data-id="element-170" />
        <CTASection data-id="element-171" />
      </main>
      <Footer data-id="element-172" />
    </div>;
}